import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  Grid,
  InputLabel,
  Skeleton,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CiEdit, CiMoneyBill } from "react-icons/ci";
import { LiaWalletSolid } from "react-icons/lia";
import { FaBoxOpen } from "react-icons/fa";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import { CloseOutlined } from "@mui/icons-material";
import { useMutation, useQuery } from "@apollo/client";
import { GET_ALL_REQUEST, GET_CHARGE_CONFIG } from "../../Utils/Queries";
import { EDIT_CHARGES_CONFIG } from "../../Utils/Mutation";
import Loader from "../Common/Loader";

const AppWidget = ({ data, loading, chargesConfig }) => {
  const [open, setOpen] = React.useState(false);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [edit_charge, setEdit_Charge] = useState({
    chargeValue: 0,
    isActive: false,
    name: "",
  });

  const navigate = useNavigate();

  const {
    data: charges,
    loading: config_loading,
    refetch,
  } = useQuery(GET_CHARGE_CONFIG);

  const [editCharge, { loading: edit_loading }] =
    useMutation(EDIT_CHARGES_CONFIG);

  const charge_configs = charges?.fetchChargeConfigs?.items || [];
  console.log(selectedCharge);

  const toggleDrawer = (newOpen, item) => () => {
    setOpen(newOpen);
    setSelectedCharge(item);
  };

  useEffect(() => {
    if (selectedCharge) {
      setEdit_Charge({
        ...edit_charge,
        chargeValue: selectedCharge?.chargeValue,
        isActive: selectedCharge?.isActive,
        name: selectedCharge?.name,
      });
    }
  }, [selectedCharge]);

  const handleEditConfig = async () => {
    await editCharge({
      variables: {
        name: edit_charge?.name,
        chargeConfigId: selectedCharge?._id,
        isActive: edit_charge?.isActive,
        chargeType: selectedCharge?.chargeType,
        // chargeType: selectedCharge?.chargeType?.toUpperCase(),
        chargeValue: parseFloat(edit_charge?.chargeValue),
        currencyId: selectedCharge?.currency,
        description: selectedCharge?.description,
      },
    })
      .then((res) => {
        setOpen(false);
        refetch();
      })
      .catch((err) => {
        console.log(err);
      });
  };

 const { data:allRequest, loading:requestLoader, error } = useQuery(GET_ALL_REQUEST);


  return (
    <>
      {edit_loading && <Loader />}
      <Grid container spacing={2}>
      {
        !chargesConfig  && (
          <>
              <Grid item lg={3}>
          <Box sx={{ bgcolor: "#fff", p: 2, height: "90px" }}>
            <Box sx={{ display: "flex", columnGap: 3, alignItems: "center" }}>
              <CiMoneyBill style={{ fontWeight: 500, fontSize: "25px" }} />
              <Typography sx={{ fontWeight: 700, color: "#4d4d4d" }}>
                Total Balance
              </Typography>
            </Box>
            <Typography variant="h2" sx={{ mt: 3, fontSize: "20px" }}>
              $
              {loading ? (
              <CircularProgress size={20} sx={{ml:1}}/>
              ) : (
                data?.getAggregateWalletBalances?.totalBalance.toLocaleString()
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid item lg={3}>
          <Box sx={{ bgcolor: "#fff", p: 2, height: "90px" }}>
            <Box sx={{ display: "flex", columnGap: 3, alignItems: "center" }}>
              <LiaWalletSolid style={{ fontWeight: 500, fontSize: "25px" }} />
              <Typography sx={{ fontWeight: 700, color: "#4d4d4d" }}>
                Mamapurse Balance
              </Typography>
            </Box>
            <Typography variant="h2" sx={{ mt: 3, fontSize: "20px" }}>
              $
              {loading ? (
             <CircularProgress size={20} sx={{ml:1}}/>
              ) : (
                data?.getAggregateWalletBalances?.totalMamapurseBalance.toLocaleString()
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid item lg={3}>
          <Box sx={{ bgcolor: "#fff", p: 2, height: "90px" }}>
            <Box sx={{ display: "flex", columnGap: 3, alignItems: "center" }}>
              <FaBoxOpen style={{ fontWeight: 500, fontSize: "25px" }} />
              <Typography sx={{ fontWeight: 700, color: "#4d4d4d" }}>
                Store Balance
              </Typography>
            </Box>
            <Typography variant="h2" sx={{ mt: 3, fontSize: "20px" }}>
              $
              {loading ? (
                <CircularProgress size={20} sx={{ml:1}}/>
              ) : (
                data?.getAggregateWalletBalances?.totalStoreBalance.toLocaleString()
              )}
            </Typography>
          </Box>
        </Grid>

        <Grid item lg={3}>
          <Box sx={{ bgcolor: "#fff", p: 2, height: "90px" }}>
            <Box sx={{ display: "flex", columnGap: 3, alignItems: "center" }}>
              <FaMoneyBillTransfer
                style={{ fontWeight: 500, fontSize: "25px" }}
              />
              <Typography sx={{ fontWeight: 700, color: "#4d4d4d" }}>
                Payment Requests
              </Typography>
            </Box>

            <Box
              sx={{
                mt: 2.3,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
            {
              requestLoader ? <CircularProgress size={20} sx={{ml:1}}/> : <Typography variant="h2" sx={{ fontSize: "26px" }}>
             {allRequest?.fetchAllPendingWithdrawals?.items?.length || "--"}
              </Typography>
            }
              
              <Button
                sx={{ color: "#FF3347" }}
                onClick={() => navigate("/dashboard/payment-request")}
              >
                View All
              </Button>
            </Box>
          </Box>
        </Grid>
          </>
        )
      }
      {
        chargesConfig && (
          <>
              {charge_configs?.map((item, index) => (
          <Grid item lg={3} key={index}>
            <Box
              sx={{
                bgcolor: item?.isActive ? "#fff" : "#ddd",
                p: 2,
                height: "90px",
                bgcolor:'#FAFAFA',
                border:'1px solid #E6E6E6',
                borderRadius:'8px'

              }}
            >
              <Box sx={{ display: "flex", columnGap: 3, alignItems: "center" }}>
                {/* <CiMoneyBill style={{ fontWeight: 500, fontSize: "25px" }} /> */}
                <Typography sx={{ fontWeight: 400, color: "#4d4d4d" }}>
                  {item?.name}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h2" sx={{ mt: 3, fontSize: "20px" }}>
                  {item.name === "Seller surcharge"
                    ? "$"
                    : item.name === "Seller membership fee"
                    ? "$ "
                    : ""}
                  {loading ? (
                    <CircularProgress size={20} sx={{ml:1}} />
                  ) : (
                    item?.chargeValue.toLocaleString()
                  )}
                  {item.name === "Seller surcharge"
                    ? ""
                    : item.name === "Seller membership fee"
                    ? ""
                    : "%"}
                </Typography>

                <Typography
                  onClick={toggleDrawer(true, item)}
                  sx={{
                    bgcolor: "#E6FFED",
                    color: "#02B237",
                    p: 0.5,
                    px: 1,
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontSize: "12px",
                    mt: 2,
                    fontWeight: 500,
                    border:'1px solid #CDFEDC'
                  }}
                >
                 <CiEdit style={{color:'#02B237', fontSize:'18px', fontWeight:700}} />
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
          </>
        )
      }
      </Grid>

      <Drawer open={open} onClose={toggleDrawer(false)} anchor="right">
        <Box sx={{ height: "100vh", width: "40vw" }}>
          <Box sx={{ px: 3, py: 6 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
                {selectedCharge?.name} %
              </Typography>
              <IconButton onClick={toggleDrawer(false)}>
                <CloseOutlined />
              </IconButton>
            </Box>

            <Box sx={{ mt: 3 }}>
              <InputLabel required>Name</InputLabel>
              <TextField
                fullWidth
                value={edit_charge?.name}
                onChange={(e) =>
                  setEdit_Charge({ ...edit_charge, name: e.target.value })
                }
                margin="dense"
                helperText={selectedCharge?.description}
                FormHelperTextProps={{
                  style: {
                    fontSize: "12px",
                  },
                }}
                InputProps={{
                  style: {
                    borderRadius: "8px",
                  },
                }}
              />
              <InputLabel required sx={{ mt: 2 }}>
                Charge Value
              </InputLabel>
              <TextField
                fullWidth
                value={edit_charge?.chargeValue}
                onChange={(e) =>
                  setEdit_Charge({
                    ...edit_charge,
                    chargeValue: e.target.value,
                  })
                }
                margin="dense"
                type="number"
                InputProps={{
                  style: {
                    borderRadius: "8px",
                  },
                }}
              />

              <Box
                sx={{
                  mt: 2,
                  bgcolor: "#F2F2F2",
                  p: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ color: "#666666", fontSize: "16px" }}>
                  Deactivate
                </Typography>
                <Switch
                  sx={{ fontSize: "50px" }}
                  checked={edit_charge?.isActive}
                  onChange={(e) =>
                    setEdit_Charge({
                      ...edit_charge,
                      isActive: e.target.checked,
                    })
                  }
                />
                <Typography>Activate</Typography>
              </Box>

              <Button
                onClick={handleEditConfig}
                variant="contained"
                fullWidth
                sx={{ mt: 3, height: "45px", borderRadius: "8px" }}
              >
                Save Changes
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default AppWidget;
